export default __webpack_public_path__ + "static/handImageTwo-ae8b836d6dd0b509208bfd8057ace8d7.jpeg";